import { render, staticRenderFns } from "./TechniqueField.vue?vue&type=template&id=6b21162e"
import script from "./TechniqueField.vue?vue&type=script&lang=ts"
export * from "./TechniqueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports